import React, { Component } from 'react'
import {
  PartnersSectionContainer,
  PartnersInnerContainer,
  PartnerWrapper,
  PartnerLogo
} from './styledComponents'

class PartnersSection extends Component {
  renderPartners = partnersData => (
    <PartnersInnerContainer>
      {partnersData.map(partner => (
        <PartnerWrapper>
          <PartnerLogo
            className="lazyload"
            dataSrc={partner.logoUrl}
            // alt={partner.altText}
          />
        </PartnerWrapper>
      ))}
    </PartnersInnerContainer>
  )
  render() {
    const { partnersList } = this.props
    return (
      <PartnersSectionContainer>
        {this.renderPartners(partnersList)}
      </PartnersSectionContainer>
    )
  }
}

export default PartnersSection



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/PartnersSection/index.js